/**
 * Identidade estável de um `File` do browser.
 *
 * `File` não tem id — o trio nome+tamanho+`lastModified` é o que o browser
 * oferece, e é o mesmo usado por `composer-attachments.vue` (fila de
 * miniaturas) e por `send-message-anexos-upload-mixin.js` (estado do
 * upload). Extraído para cá porque os dois componentes precisam da MESMA
 * chave para o mesmo arquivo — duas implementações divergiriam no primeiro
 * arquivo cujo `lastModified` truncasse diferente entre elas, e o upload
 * "sumiria" da miniatura (chave de status ≠ chave de preview).
 *
 * ★ [S-3, design-conformance 05/09] Anexo PERSISTIDO (reaberto depois do F5)
 * não tem `lastModified` — não é um `File` de verdade, é o metadado do bloco
 * técnico (`utils/anexos-da-mensagem.js`), adaptado por
 * `paraItemDeAnexo` (`utils/anexo-persistido-para-item.js`) para reusar a
 * MESMA miniatura do anexo ao vivo. Esse adaptador carrega `upload_id`, que
 * um `File` do browser nunca tem — usá-lo como chave, quando presente, é
 * mais estável que o trio (dois anexos reabertos com nome+tamanho iguais na
 * MESMA mensagem colidiriam no trio, nunca no `upload_id`).
 *
 * ★ [spec-008 T028] A ENTREGA do agente (`utils/artefato-para-item.js`) entra
 * pela mesma porta, com `id_objeto` — o id do objeto no store de arquivos, que
 * é a chave do download. Ele vem ANTES do `upload_id` no desempate por ser o
 * único dos três que o servidor garante único; o prefixo (`artefato:` ×
 * `persistido:`) existe para que um `upload_id` e um `id_objeto` de mesmo
 * valor nunca colidam na MESMA fila.
 */
export const chaveDoArquivo = (arquivo) => {
  if (!arquivo) return ''
  if (arquivo.id_objeto) return 'artefato:' + arquivo.id_objeto
  if (arquivo.upload_id) return 'persistido:' + arquivo.upload_id
  return [arquivo.name, arquivo.size, arquivo.lastModified].join('|')
}
